module.exports = __webpack_public_path__ + "img/mapa-ubs.e60d8de4.png";